export default __webpack_public_path__ + "static/media/mb-sprite.fe08d70a.png";